import React, {useEffect, useState} from "react";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import EventBus from "../../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import CCButton from "../Common/CCButton";
import {CheckCircle, Info, Visibility, VisibilityOff, Error} from "@mui/icons-material";
import {updateObject} from "../../util/utility";
import EnlilAxios from "../../util/EnlilAxios";
import projectPlanPhaseApprovalEnterpriseComponent from "../../eoec/ec/impl/ProjectPlan/ProjectPlanPhaseApprovalEnterpriseComponent";


export default function ProjectPlanPhaseExecuteApproval(props: any) {
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [controls, setControls] = useState<any>({"Password": {"value": ""}});
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [passwordError, setPasswordError] = useState<boolean>(false);

    function enterpriseComponentUpdateStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentUpdateCompletedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(false)
        let projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseApproval")!
        projectPlanPhaseApprovalEnterpriseComponent.invalidate();
        
        EventBus.components.emit("project-plan-phase-submit-for-approval-save");
    }

    useEffect(() => {
        const projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseApproval")!

        projectPlanPhaseApprovalEnterpriseComponent.addUpdateStartedListener(enterpriseComponentUpdateStartedListener);
        projectPlanPhaseApprovalEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

        return () => {
            projectPlanPhaseApprovalEnterpriseComponent.removeUpdateStartedListener(enterpriseComponentUpdateStartedListener);
            projectPlanPhaseApprovalEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
        }

    }, [props.enterpriseComponent]);

    function onCancelHandler() {
        EventBus.components.emit("project-plan-phase-execute-approval-cancel");
    }

    function saveHandler() {
        setBackgroundOperation(true);

        // @ts-ignore
        EnlilAxios({
            method: "POST",
            url: "t8/v1/authenticate2",
            json: true,
            data: {
                "Password": controls["Password"].value
            },
        }).then((response: any) => {
            if (response.data.Code === "CC-JJDU-9EE3") {
                setPasswordError(true);
                setBackgroundOperation(false);
            }
            if (response.data.Code === "CC-MDKW-OOD0") {
                setPasswordError(false);

                const projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseApproval")!

                projectPlanPhaseApprovalEnterpriseComponent.setAttributeValue("Status", "APPROVED")
                projectPlanPhaseApprovalEnterpriseComponent.executeUpdate();
            }
        }).catch((error: any) => {
            EventBus.error.emit("show-system-error");
        });
    }

    function passwordChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["Password"], {
            value: event.target.value,
            touched: true,
            valid: true,
            helperText: null,
            invitationInProgress: false,
            userExistsInClinic: false,
            userExistsInProvider: false,
            userDoesNotExist: null,
            mainEmailVerifiedState: null,
            invitationSaved: false,
        });
        const updatedForm = updateObject(controls, {
            "Password": updatedFormElement,
        });

        setControls(updatedForm);
    }

    function updateView() {
        let buttonHandler = null;

        let firstButtonHandlerContent = (
            <CCButton
                className={css_buttons.redStandardButton}
                onClick={onCancelHandler}>
                Cancel
            </CCButton>
        );

        let secondButtonHandlerContent = (
            <CCButton
                disabled={controls["Password"].value.length === 0}
                className={css_buttons.blueStandardButton}
                animate={backgroundOperation}
                onClick={() => saveHandler()}>
                Save
            </CCButton>
        )

        buttonHandler = (
            <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                {firstButtonHandlerContent}
                {secondButtonHandlerContent}
            </DialogActions>
        );

        let adornments: any = {}

        if (!controls["Password"].valid && controls["Password"].touched) {
            adornments["startAdornment"] = (
                <InputAdornment position="start">
                    <Error color="error" />
                </InputAdornment>
            );
        }
        if (controls["Password"].valid && controls["Password"].touched) {
            adornments["startAdornment"] = (
                <InputAdornment position="start">
                    <CheckCircle color="primary" />
                </InputAdornment>
            );
        }

        // @ts-ignore
        adornments["endAdornment"] = (
            <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </InputAdornment>
        )
        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#000000"}}>Approve</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", margin: "20px 20px 20px 0"}}>
                                <div>
                                    <Info sx={{marginTop: "5px", width: "60px", height: "60px", color: "#F1C40F"}}/>
                                </div>
                                <div>
                                    <Typography style={{margin: "19px 0 0 6px", fontSize: "16px", fontWeight: 400, color: "#000000"}}>Please enter your password.</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", margin: "0 20px 20px 0", width: "100%"}}>
                                <TextField
                                    key="Password"
                                    margin="dense"
                                    placeholder="Enter your password"
                                    type={showPassword ? "text" : "password"}
                                    error={(!controls["Password"].valid || passwordError) && controls["Password"].touched}
                                    fullWidth={true}
                                    helperText={passwordError ? "Incorrect password" : "A value is required."}
                                    id="Password"
                                    label="Password *"
                                    onChange={(event) => passwordChangedHandler(event)}
                                    value={controls["Password"].value}
                                    variant="outlined"
                                    slotProps={{
                                        input: {
                                            startAdornment: adornments["startAdornment"],
                                            endAdornment: adornments["endAdornment"],
                                        },
                                        inputLabel: {shrink: true}
                                    }}
                                />
                            </div>
                        </div>
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {updateView()}
        </>
    )
}
